import registrationInstance from '../instance'

const updateChangeSettings = (data) => {
	return registrationInstance.put('/company/changeSettings', data)
}

export default updateChangeSettings
